// This file will be deleted once all the calculators are configBuilder free
// to be deleted

import { iconUri } from '@nerdwallet/nw-client-lib/cdn';
import { ApplyNowLink } from '@nerdwallet/react-apply-now';

import {
  getHACFreeCreditScore,
  HOME_LIGHT_IMPRESSION,
} from '../../lib/analytics-constants';
import registerLink from '../../lib/register-link';

const config = {
  cards: [
    {
      header: 'Rates',
      text: 'A low rate can save you hundreds each year.',
      img: iconUri('House_pricetag'),
      alt: 'House with price tag',
      link: {
        url: '/mortgages/mortgage-rates?trk_source=mortgages_hac_toolcard&trk_content=rates_toolcard_card+pos1&trk_destination=mortgage-rates&trk_origin=calculate-mortgage-payment&trk_app=tool&purchasePrice={{0}}&downPayment={{1}}&zipCode={{2}}&annualIncome={{3}}&bypass=true',
        text: 'Compare mortgage rates',
      },
      keys: [
        {
          key: 'adjustedOutputs.suggestedPurchasePrice',
        },
        {
          key: 'adjustedOutputs.downPayment',
        },
        {
          key: 'outputs.zip',
        },
        {
          key: 'inputs.householdIncome',
        },
      ],
    },
    {
      header: 'Credit',
      text: 'See how a mortgage impacts your score.',
      img: iconUri('Credit_score'),
      alt: 'Credit score gauge',
      link: registerLink(
        'hac',
        {
          element: 'ad_unit',
          location: 'toolcard_card+pos2',
        },
        'Get your free credit score'
      ),
      impressionEventPayload: getHACFreeCreditScore(),
    },
    {
      header: 'Lenders',
      text: 'Get your true budget and find a home with ease.',
      img: iconUri('Approval'),
      alt: 'Thumbs up with dollar sign',
      link: {
        url: '/mortgages/mortgage-pre-approval?trk_source=mortgages_hac_toolcard&trk_content=preapproval_toolcard_card+pos3&trk_destination=mortgage-pre-approval&trk_origin=calculate-mortgage-payment&trk_app=tool&purchasePrice={{0}}&downPayment={{1}}&zipCode={{2}}&annualIncome={{3}}',
        text: 'Get preapproved',
      },
      keys: [
        {
          key: 'adjustedOutputs.suggestedPurchasePrice',
        },
        {
          key: 'adjustedOutputs.downPayment',
        },
        {
          key: 'outputs.zip',
        },
        {
          key: 'inputs.householdIncome',
        },
      ],
    },
    {
      header: 'Agents',
      text: 'Get matched with a top agent in your area.',
      img: iconUri('Real_estate_1'),
      alt: 'Real estate sign',
      link: {
        linkComponent: ApplyNowLink,
        text: 'Find a real estate agent',
        props: {
          linkType: 'apply_now_button',
          logImpression: false,
          link: '/redirect/eeadcaf6-38db-11eb-a727-ef6ff84e35fe',
        },
        getAdditionalProps: (impressionData) => ({
          impressionId: impressionData?.impressionId,
        }),
      },
      impressionEventPayload: {
        ...HOME_LIGHT_IMPRESSION,
        payload: {
          ...HOME_LIGHT_IMPRESSION.payload,
          section_name: 'mortgages_home_affordability_tool_card',
          section_position: 6,
        },
      },
    },
  ],
};
export default config;
